import { tv } from 'tailwind-variants'

export const switchVariants = tv({
  base: '',
  slots: {
    root: 'relative inline-flex h-9 w-16 cursor-pointer rounded-full border transition-colors duration-200 ease-in-out disabled:cursor-not-allowed lg:h-7 lg:w-14',
    thumb:
      'my-auto inline-block h-8 w-8 transform rounded-full bg-white shadow-md transition duration-200 ease-in-out aria-disabled:cursor-not-allowed aria-disabled:shadow-none lg:h-6 lg:w-6',
  },
  variants: {
    checked: {
      true: {
        root: 'border-secondary bg-secondary disabled:border-secondary/50 disabled:bg-secondary/50',
        thumb: 'translate-x-[29px] aria-disabled:bg-white/50',
      },
      false: {
        root: 'border-primary bg-primary/30 disabled:border-primary/50 disabled:bg-primary/20 dark:border-accent-3/60 dark:bg-white/20',
        thumb: 'translate-x-[1px] aria-disabled:bg-white/50',
      },
    },
  },
})
